import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { ISelectType, useFetch } from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ECalendarSource } from "../model";
import { ScheduleAppointmentService } from "../Schedule.service";
import { Extension } from "../../../models/intalled-extensions";
import ExtensionStoreService from "../../../services/extensionsStore.service";
import ExtensionSettingsService from "../../../services/extensionSettings.service";
interface IPeriodProps {
  value: ECalendarSource;
  onChange: (v: ECalendarSource) => void;
}

const service = new ExtensionSettingsService();
const CalendarSource: React.FC<IPeriodProps> = ({ onChange, value }) => {
  const [types, setTypes] = useState<ISelectType[]>([]);

  const [showConsultation, setShowConsultation] = useState(false);

  const [showExams, setShowExams] = useState(false);

  const [extensionsLoaded, setExtensionsLoaded] = useState(false);

  const { sendRequest } = useFetch(ScheduleAppointmentService.getTypes);

  const { sendRequest: extensionConfig, loading: loadingExtensionConfigs } =
    useFetch(service.getExtensionConfig);

  const { t } = useTranslation();

  const fetch = useCallback(async () => {
    const { data, success } = await sendRequest(null);

    if (success && data) {
      setTypes(
        data.filter((d) => {
          if (d.code === "3") return showConsultation;
          if (d.code === "2") return showExams;
          return true;
        })
      );
    }
  }, [sendRequest, showConsultation, showExams]);

  const fetchExtensionConfig = useCallback(
    async (Identifier: string) => {
      const { data, success } = await extensionConfig({
        ExtensionCode: Extension.SCHEDULE,
        Identifier,
      });

      if (data && success) {
        setExtensionsLoaded(true);
        console.log(data);
        const raw = Array.isArray(data)
          ? data.some((conf) => conf.value === "true")
          : "false";

        const shouldShow: boolean = !!raw;

        switch (Identifier) {
          case "ShowConsultationToSchedule":
            setShowConsultation(shouldShow);
            break;
          case "ShowExamsToSchedule":
            setShowExams(shouldShow);
            break;
        }
      }
    },
    [extensionConfig]
  );

  useEffect(() => {
    fetchExtensionConfig("ShowExamsToSchedule");
    fetchExtensionConfig("ShowConsultationToSchedule");
  }, [fetchExtensionConfig]);

  useEffect(() => {
    if (!extensionsLoaded) return;
    fetch();
  }, [fetch, extensionsLoaded]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: ECalendarSource
  ) => {
    onChange(newAlignment);
  };

  return (
    <ToggleButtonGroup
      color="primary"
      size="small"
      fullWidth
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      sx={{ paddingX: 4 }}
    >
      {types.map((t) => (
        <ToggleButton value={t.code!} key={t.id}>
          {t.name}
        </ToggleButton>
      ))}
      <ToggleButton value={ECalendarSource.BOTH}>
        {t("components.schedule.menu.source.both")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
export default CalendarSource;
